module.exports = __webpack_public_path__ + "assets/img/avatar-s-20.32972323.jpg";